import { getReduxType } from "../../utils/Actions";

export const baseActionCreator = (
    statusName : string,
    actionType : string,
    entityName : string,
    entityId : string
) => ({
    type: getReduxType(statusName, actionType, entityName),
    params: { id: entityId }
});

export const baseActionRequest = (
    actionType : string,
    entityName : string,
    entityId : string
) => baseActionCreator('request', actionType, entityName, entityId);

export const baseActionSuccess = (
    actionType : string,
    entityName : string,
    entityId : string
) => baseActionCreator('success', actionType, entityName, entityId);

export const baseActionFail = (
    actionType : string,
    entityName : string,
    entityId : string
) => baseActionCreator('fail', actionType, entityName, entityId);